import * as S from './CheckAvailabilityAltAcco.styles';

const CheckAvailabilityAltAcco = ({handlOpenCalendar = () => {}, needBorderLine = false}) => {
  const onClickCheckAvailability = () => {
    handlOpenCalendar();
  };
  return (
    <S.Container>
      {needBorderLine && <S.BorderLine />}
      <S.Description>Add Dates to check availability</S.Description>
      <S.ButtonWrapper onClick={onClickCheckAvailability}>Check Availability</S.ButtonWrapper>
    </S.Container>
  );
};

export default CheckAvailabilityAltAcco;
